import { render, staticRenderFns } from "./video-box-group.vue?vue&type=template&id=608f1d56&scoped=true&"
import script from "./video-box-group.vue?vue&type=script&setup=true&lang=ts&"
export * from "./video-box-group.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./video-box-group.vue?vue&type=style&index=0&id=608f1d56&prod&lang=scss&scoped=true&"
import style1 from "./video-box-group.vue?vue&type=style&index=1&id=608f1d56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608f1d56",
  null
  
)

/* custom blocks */
import block0 from "./video-box-group.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports